import React from "react";
import "./ServiceRate.css";
import { getData } from "app/data";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

export default function Index(props) {
  const contentData = getData(props.name)
  return (
    <section className="serviceRateContent" >
      <div className="container">
        {contentData.map((item, idx) => {
          return (
            <div className="row" key={idx}>
              <div className="text-wrapper">
                <div className="title">
                  <h2>{item.title}</h2>
                </div>
                <div className={props.type ? "top-title" : "text"}>
                  {item.text && Array.isArray(item.text) ?
                    item.text.map((textItem, index) => (
                      <div key={index}>
                        <p>
                          {props.type ? null : idx === 2 ? <FontAwesomeIcon icon={faCheckCircle} /> : idx === 0 ?
                            <FontAwesomeIcon icon={faDollarSign} /> : null}
                          {textItem}</p>

                      </div>
                    )) :
                    <span>{item.text}</span>
                  }
                  {/* {(idx === 1 && props.more) ? <div className="btn-wrapper">
                    <Link
                      className="green-button"
                      to={"/service-rate/request-a-demo"}
                    >
                      <FormattedMessage id={"request_a_free_demo"} />
                    </Link>
                  </div> : null} */}

                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
